module.exports = __webpack_public_path__ + "static/media/ic_coin.31e79c40.png";